var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fullscreen-success"},[_c('icon-completed-filled',{staticClass:"container-fullscreen-success__icon",attrs:{"size":"md1"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }